var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaquetes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6665 32.0026C27.746 32.0026 26.9998 32.7488 26.9998 33.6693C26.9998 34.5898 27.746 35.3359 28.6665 35.3359H35.3332C36.2536 35.3359 36.9998 34.5898 36.9998 33.6693C36.9998 32.7488 36.2536 32.0026 35.3332 32.0026H28.6665Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6665 15.3359C15.9051 15.3359 13.6665 17.5745 13.6665 20.3359V43.6693C13.6665 46.4307 15.9051 48.6693 18.6665 48.6693H45.3332C48.0946 48.6693 50.3332 46.4307 50.3332 43.6693V20.3359C50.3332 17.5745 48.0946 15.3359 45.3332 15.3359H18.6665ZM45.3332 18.6693H18.6665C17.746 18.6693 16.9998 19.4154 16.9998 20.3359V25.3359H46.9998V20.3359C46.9998 19.4154 46.2536 18.6693 45.3332 18.6693ZM16.9998 43.6693V28.6693H46.9998V43.6693C46.9998 44.5898 46.2536 45.3359 45.3332 45.3359H18.6665C17.746 45.3359 16.9998 44.5898 16.9998 43.6693Z",
    fill: "#FCFCFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2A80BD",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#246FB6",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#329BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#2E8FC3",
    stopOpacity: 0.30816
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaquetes);
export default __webpack_public_path__ + "static/media/paquetes.f8657ad137097f2c7ed8f8bb5787569d.svg";
export { ForwardRef as ReactComponent };